import React, {Component} from 'react';
import '../css/Button.css';
import {Link} from 'react-router-dom';
import {COLORS} from '../constants';
import {alterColor} from '../utils';

class Button extends Component {

  static defaultProps = {
    label: '',
    onClick: () => undefined,
    color: 'orange',
    labelColor: 'fadedWhite',
    borderColor: 'orange',
    style: null,
  }

  constructor(props) {
    super(props);
    const {color} = this.props;
    // get initial button color
    const buttonColor = COLORS[color] || COLORS.coral;
    // calc active button color
    const buttonColorActive = alterColor(buttonColor, 20);

    this.state = {
      buttonColor,
      buttonColorActive,
      initialColor: buttonColor,
    };

    // empty ref to element
    this.element = null;
  }

  handleMouseEnter = (e) => {
    const {buttonColorActive} = this.state;

    this.element.style.backgroundColor = buttonColorActive;
  }

  handleMouseLeave = (e) => {
    const {buttonColor} = this.state;

    this.element.style.backgroundColor = buttonColor;
  }


  render() {
    let {
      label,
      link,
      onClick,
      labelColor,
      style,
    } = this.props;

    //const buttonColor = COLORS[color] || COLORS.coral;
    const {buttonColor} = this.state;
    const fontColor = COLORS[labelColor] || COLORS.white;

    let containerStyle = {
      ...s.container,
      backgroundColor: buttonColor,
      color: fontColor,
    }

    if (style) {
      containerStyle = {
        ...containerStyle,
        ...style,
      }
    }

    if (link) {
      return(
        <Link to={link}>
        <div 
          id="Button"
          style={containerStyle}
          className="Button-button"
          onClick={onClick}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          ref={(element) => this.element = element}
        >
          <div style={s.label}>
            {label}
          </div>
        </div>
        </Link>
      )
    }

    else {
      return(
        <button
          id="Button"
          style={containerStyle}
          className="Button-button"
          onClick={onClick}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          ref={(element) => this.element = element}
        >
          <div style={s.label}>
            {label}
          </div>
        </button>
      )
    }
  }
}


const s = {
  container: {
    padding: '15px',
    borderRadius: '4px',
    userSelect: 'none',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'inherit',
    border: 'none',
  },
  label: {
    color: COLORS.fadedWhite,
  },
}

export default Button;



// WEBPACK FOOTER //
// ./src/main/Button.js